import { ApiError } from '@/services/api'

type ErrorDetail = string | string[] | Record<string, unknown>
type NormalizedDetail = { text: string }

export const normalizeApiErrorResponse = (errorResponse: ApiError) => {
  const { error_message: message, details } = errorResponse
  const normalizedDetails: NormalizedDetail[] = []

  const formatKey = (key: string): string => {
    return key
      .replace(/_/g, ' ')
      .replace(/([A-Z])/g, ' $1')
      .replace(/^\w/, (c) => c.toUpperCase())
      .trim()
  }

  const processDetails = (detailsObj: ErrorDetail, parentPath: string[] = []): void => {
    if (typeof detailsObj === 'string') {
      normalizedDetails.push({ text: detailsObj })
    } else if (Array.isArray(detailsObj)) {
      const keyPath = parentPath.length > 0 ? parentPath.map(formatKey).join(' -> ') + ': ' : ''

      detailsObj.forEach((detail) => {
        normalizedDetails.push({ text: `${keyPath}${detail}` })
      })
    } else if (typeof detailsObj === 'object' && detailsObj !== null) {
      Object.entries(detailsObj).forEach(([key, value]) => {
        const newPath = [...parentPath, key]
        processDetails(value as ErrorDetail, newPath)
      })
    }
  }

  if (details) {
    processDetails(details as ErrorDetail)
  }

  return { message, details: normalizedDetails }
}
